
import ProductLayout from "layouts/ProductLayout";
import ManageProduct from "components/ManageProduct";
import FooterProduct from "components/ManageProduct/FooterProduct";



function ManageProductPage() {

  return (
    <>
      <ProductLayout namePage="จัดการสินค้าและสต็อก" footerComponent={<FooterProduct />}  >
        <div className="layout-content">
          <ManageProduct />
        </div>
      </ProductLayout>
    </>
  );
}

export default ManageProductPage;